import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import CockpitNotificationsApi from '../generated/api/CockpitNotifications';

export default (service: Servicelayer) => ({
  ...CockpitNotificationsApi(service),

  // Add custom calls here

});
